import Pagination from "../../components/table/Pagination";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import ArchiveFilterListBox from "componentsTemplate/ArchiveFilterListBox/ArchiveFilterListBox";

import Image from "componentsTemplate/Image";
import AdvertisementCard from "components/cards/AdvertisementCard";
import ClassifiedsCards from "components/classifieds/classifieds";
import { useEffect, useState } from "react";
import { InstitutionalResponse, getInstitutional } from "services/PageService";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { index } from "services/post/ClassifiedService";
import { last, set } from "lodash";
import FiltersPost from "components/posts/FiltersPost";
import { getClassifiedFilters } from "services/post/FilterService";
import Input from "componentsTemplate/Input/Input";
import Advertising from "components/ad/Advertising";

const posts: any[] = [{}];

const Classifieds: React.FC = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [institutional, setInstitutional] = useState<InstitutionalResponse | null>(null);

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;
  const [banner, setBanner] = useState("");
  const [pagination, setPagination]: any = useState(null);
  const [filtersData, setFiltersData] = useState<any>();
  const [paginationData , setPaginationData] = useState<any>();

  useEffect(() => {
    if (institutional) {
      setBanner(
        `${urlBase}/storage/images/institutional/banners/${
          institutional?.banners?.find((e) => e.name == "Banner classificados")
            ?.banner_path
        }`
      );
    }
  }, [institutional]);

  const fetchInstitutional = async () => {
    try {
      const data = await getInstitutional(15);
      setInstitutional(data);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  const fetchData = async (current_page = 1, per_page = 8, filters : any = {}) => {
    setLoading(true);
    let dados : any = {
      page: current_page,
      per_page: per_page,
    };

    if (filters.category) {
      dados = { ...dados, category_id: filters.category.value };
    }

    if (filters.subCategory) {
      dados = { ...dados, subcategory_id: filters.subCategory.value };
    }

    if (filters.country) {
      dados = { ...dados, country: filters.country.value };
    }

    if (filters.state) {
      dados = { ...dados, state: filters.state.value };
    }
    
    if (filters.city) {
      dados = { ...dados, city: filters.city.value };
    }

    if (filters.search) {
      dados = { ...dados, search: filters.search };
    }

    try {
      const response = await index(dados);
      setPaginationData({
        current_page: response.current_page,
        last_page: response.last_page,
        per_page: response.per_page,
        total: response.total,
      });
      setData(response.data);

      setLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  useEffect(() => {
    fetchInstitutional();
    fetchData();
  }, []);

  const handleFilters = (filters: any) => {
    fetchData(1, 8, filters);
  }

  const handlePaginationChange = async (page: number) => {
    await fetchData(page, 8, filtersData);
  }

  return (
    <div className="flex flex-col items-center mt-5 p-1">
      <div
        className="flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-5xl py-44 brightness-100 text-white rounded-3xl">
          Classificados
        </span>
      </div>
      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt;{" "}
        <Link to={"/classificados"}>Classificados</Link>
      </span>

      <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] mt-20 mb-10">
        <div className="flex flex-col lg:flex-row text-justify items-center gap-10 p-2 bg-primary-50 dark:bg-gray-600 rounded-3xl">
          <span className="flex w-full text-justify">
            Vocês pediram e nós atendemos !!
            <br />
            <br />
            Agora o Radar tem a área de Classificados onde vocês podem vender
            seu carro , seu imóvel, suas roupas second hand e seus móveis também
            !
            <br />
            <br />
            Entrem e confiram todas as ofertas que as Mags colocaram para
            vocês!!
          </span>
          <iframe
            className="shadow-2xl w-full sm:w-[30rem] lg:w-[50rem] h-[12rem] sm:h-[17.9rem] rounded-3xl lg:mr-[-10%]"
            width="1980"
            height="1024"
            src={
              institutional?.videos?.find(
                (e) => e.name == "Video de introdução"
              )?.video_path ?? ""
            }
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>

      <div className="pt-5 w-full px-4 sm:px-0 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <div>

          <FiltersPost 
            filters={['category', 'subcategory', 'country', 'state', 'city', 'search']} 
            handleFilters={handleFilters} 
            getFilters={getClassifiedFilters} 
            filtersData={filtersData}
            setFiltersData={setFiltersData}
          />

          {/* <div className="mt-3">
            <div className="flex gap-5">
              <input
                placeholder="Valor Mínimo"
                type="number"
                value={valueMin}
                onChange={(e) => setValueMin(e.target.value)}
                className={`mt-1 rounded-full text-sm font-normal h-11 px-4 py-3 block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200/50 bg-white`}
              />
              <input
                placeholder="Valor Máximo"
                type="number"
                value={valueMax}
                onChange={(e) => setValueMax(e.target.value)}
                className={`mt-1 rounded-full text-sm font-normal h-11 px-4 py-3 block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200/50 bg-white`}
              />
            </div>
          </div> */}

          <div className="grid place-items-center grid-cols-1 sm:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8 mt-8 lg:mt-10">
            {
              !loading ? (
                <>
                  {data ? (
                    data.map((item: any) => (
                      <AdvertisementCard
                        adImg={
                          urlBase +
                            "/storage/images/posts/classifieds/attachments/" +
                            item.attachments[0]?.path ?? ""
                        }
                        adTitle={item.name ?? ""}
                        adDescription={item.description ?? ""}
                        adPrice={
                          (item.currency?.sigle ?? "") + " " + (item.value ?? "")
                        }
                        authorImg={
                          urlBase +
                            "/storage/users/" +
                            item.post?.user?.avatar_path ?? ""
                        }
                        authorName={item.post?.user?.name ?? ""}
                        adDate={item.created_at ?? ""}
                        id={item.id ?? ""}
                      />
                    ))
                  ) : (
                    <div className="bg-primary-200 border shadow rounded-3xl w-100 p-8">
                      Não há anúncios disponíveis com essas especificações.
                    </div>
                  )}
                </>
              ) : (
               <div className="spinner border-primary-600 mt-5"></div>
              )
            }
          </div>

          {/* PAGINATIONS */}
          {/* <div className="flex flex-col gap-y-4 mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:flex-row sm:justify-between items-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
            {pagination != null ? (
              <Pagination pagination={pagination} buscarInfo={fetchData} />
            ) : null}
          </div> */}

          {
            !loading && data.length > 0 && (
              <div className="mt-10 flex justify-start">
                <Pagination pagination={paginationData} fetchData={(page: number) => handlePaginationChange(page)} />
              </div>
            )
          }

        </div>

        {/* <div className="bg-black w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-52 dark:bg-gray-600 rounded-3xl overflow-hidden shadow-md mt-10"></div>
        <div className="px-4 sm:px-0">
          <ClassifiedsCards />
        </div> */}
      </div>

      <div className="sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <div className="my-10">
          <Advertising type="horizontal" />
        </div>
      </div>

    </div>
  );
};

export default Classifieds;
